/**
 * Hand a Blob to the browser as a file download.
 *
 * Extracted from exportCsv.js so that server-generated downloads share one implementation,
 * and so component tests can mock a single module instead of asserting on a synthetic
 * anchor element.
 *
 * @param {Blob} blob - the file contents
 * @param {string} filename - the name to save it under
 */
export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  // Firefox needs the anchor in the document before a synthetic click registers.
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
